<template>

  <svg
    t="1632727406643"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="6318"
    width="64"
    height="64"
  ><path d="M468.87499971 536.37499971l86.2499997 0-43.12500029-136.87499971-43.12500029 136.87499971zM811.99999971 387.6875l0-175.68749971-175.68749971 0-124.3125-124.3125-124.3125 124.3125-175.68749971 0 0 175.68749971-124.3125 124.3125 124.3125 124.3125 0 175.68749971 175.68749971 0 124.3125 124.3125 124.3125-124.3125 175.68749971 0 0-175.68749971 124.3125-124.3125-124.3125-124.3125zM598.24999971 662.00000029l-26.2500003-74.9999997-119.9999997 0-26.25000029 74.9999997-71.2500003 0 119.99999971-337.5 74.99999971 0 119.99999971 337.5-71.2500003 0z" p-id="6319" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconShapeAuto',
} as DefineComponent
</script>